import { MyLearningService } from "@/services";
import { useQuery } from "@tanstack/react-query"


export const useMyLearning = (page: number, pageSize: number, status: 'pending' | 'in-progress' | 'completed', search: string) => {
    const {
        data: response, 
        isFetching,
        isError,
        error,
    } = useQuery({
        queryKey: ["my-learning", page, pageSize,status, search],
        queryFn: ({ signal }) => 
            MyLearningService.getCoursesPaginated(page, pageSize, status, search, signal),
        staleTime: 60 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });

    return {
        courses: response?.list ?? [],
        total: response?.total ?? 0,
        isLoading: isFetching,
        isError,
        error,
    };
};